module.exports = __webpack_public_path__ + "static/media/gokul_nambiar.8a1adce0.png";